import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import './index.css';

import App from './App';
import reportWebVitals from './reportWebVitals';
import { KeycloakProvider } from './KeycloakContext';

const OLD_WORKER_RELOAD_KEY =
    'carsharing-old-service-worker-cleanup';

const getWorkerScriptUrl = (registration) => {
    const worker =
        registration.active
        || registration.waiting
        || registration.installing;

    return worker?.scriptURL || '';
};

const removeOldApplicationServiceWorker = async () => {
    if (!('serviceWorker' in navigator)) {
        return false;
    }

    let removedOldWorker = false;

    try {
        const registrations =
            await navigator.serviceWorker.getRegistrations();

        for (const registration of registrations) {
            const scriptUrl =
                getWorkerScriptUrl(registration);

            const isOldApplicationWorker =
                scriptUrl.endsWith('/service-worker.js')
                && !scriptUrl.endsWith(
                    '/firebase-messaging-sw.js'
                );

            if (!isOldApplicationWorker) {
                continue;
            }

            const removed =
                await registration.unregister();

            if (removed) {
                removedOldWorker = true;
            }
        }

        if ('caches' in window) {
            const cacheNames =
                await caches.keys();

            await Promise.all(
                cacheNames.map((cacheName) => {
                    const normalizedName =
                        cacheName.toLowerCase();

                    const isOldApplicationCache =
                        normalizedName.includes('workbox')
                        || normalizedName.includes('precache')
                        || normalizedName.includes('runtime')
                        || normalizedName.includes('carsharing');

                    if (!isOldApplicationCache) {
                        return Promise.resolve(false);
                    }

                    return caches.delete(cacheName);
                })
            );
        }
    } catch (error) {
        console.error(
            'Erro ao remover o Service Worker antigo:',
            error
        );
    }

    return removedOldWorker;
};

const registerFirebaseServiceWorker = async () => {
    if (!('serviceWorker' in navigator)) {
        return null;
    }

    try {
        const registration =
            await navigator.serviceWorker.register(
                '/firebase-messaging-sw.js',
                {
                    scope: '/',
                    updateViaCache: 'none',
                }
            );

        await registration.update();

        console.log(
            'Firebase Service Worker registado:',
            registration.scope
        );

        return registration;
    } catch (error) {
        console.error(
            'Erro ao registar o Firebase Service Worker:',
            error
        );

        return null;
    }
};

const renderApplication = () => {
    const rootElement =
        document.getElementById('root');

    if (!rootElement) {
        throw new Error(
            'Não foi encontrado o elemento #root.'
        );
    }

    const root =
        ReactDOM.createRoot(rootElement);

    root.render(
        <KeycloakProvider>
            <App />
        </KeycloakProvider>
    );
};

const initializeApplication = async () => {
    const removedOldWorker =
        await removeOldApplicationServiceWorker();

    /*
     * O unregister não retira imediatamente o controlo
     * do worker da página que já está aberta.
     *
     * É necessário um reload único para a página deixar
     * de estar controlada pelo worker antigo.
     */
    if (
        removedOldWorker
        && !sessionStorage.getItem(
            OLD_WORKER_RELOAD_KEY
        )
    ) {
        sessionStorage.setItem(
            OLD_WORKER_RELOAD_KEY,
            '1'
        );

        window.location.reload();

        return;
    }

    sessionStorage.removeItem(
        OLD_WORKER_RELOAD_KEY
    );

    await registerFirebaseServiceWorker();

    renderApplication();
};

initializeApplication();

reportWebVitals();